import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../../../../../utils/common'
import Button from '../../../../../../Button'
import { ICON_COLOR, ICON_HEIGHT_72, IconNG } from '../../../../../../Icon'
import Text from '../../../../../../Text'
import {
  QA_NAME_LISTING_PHOTO_MOSAIC_ADD,
  QA_NAME_LISTING_PHOTO_MOSAIC_EMPTY_STATE,
} from '../RentalPortalListingPhotoMosaic.constants'

import * as styles from './RentalPortalListingPhotoMosaicEmpty.module.css'

import PlusIcon from '../../../../../../../icons/plus.svg'
import RentalPortalIcon from '../../../../../../../icons/rental-portal.svg'

function RentalPortalListingPhotoMosaicEmpty({ canAdd, onAdd }) {
  const { t } = useTranslation()

  return (
    <div
      {...getQaSelector({ value: QA_NAME_LISTING_PHOTO_MOSAIC_EMPTY_STATE })}
      className={styles.RentalPortalListingPhotoMosaicEmpty}
    >
      <IconNG
        Icon={RentalPortalIcon}
        color={ICON_COLOR.SecondaryTextColor50}
        size={ICON_HEIGHT_72}
      />
      <Text isSecondary>{t('RentalPortal.ListingProfileNoPhotosKey')}</Text>
      {canAdd ? (
        <Button.Flat
          beforeIconProps={{ Icon: PlusIcon }}
          qaName={QA_NAME_LISTING_PHOTO_MOSAIC_ADD}
          text={t('RentalPortal.ListingProfileAddPhotosKey')}
          onClick={onAdd}
        />
      ) : null}
    </div>
  )
}

export default RentalPortalListingPhotoMosaicEmpty
